import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import OverviewMobile from "./OverviewMobile";
import OverviewDesktop from "./OverviewDesktop";
import { useSelections } from "../../context/Selections";

function Overview({ app, config }) {
	const isMobile = useMediaQuery({ query: "(max-width: 980px)" });
	const { selections } = useSelections();
	const [needFilter, setNeedFilter] = useState(true);
	useEffect(() => {
		async function filterData() {
			const selectionsArr = await selections.filter((item) =>
				item.qField.includes("Ano")
			);
			const selectionsMes = await selections.filter((item) =>
				item.qField.includes("Nr Mês")
			);
			if (
				selectionsArr[0]?.qSelectedCount === 1 &&
				selectionsMes[0]?.qSelectedCount === 1
			) {
				setNeedFilter(true);
				return;
			}
			setNeedFilter(false);
		}
		filterData();
	}, [selections]);

	return isMobile ? (
		<OverviewMobile needFilter={needFilter} app={app} config={config} />
	) : (
		<OverviewDesktop needFilter={needFilter} app={app} config={config} />
	);
}

Overview.defaultProps = {
	app: null,
	config: {},
};

Overview.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Overview;
